"use client";

import React from "react";
import { ChipiProvider } from "@chipi-stack/chipi-react";
import type { ChipiSDKConfig } from "@chipi-stack/types";

interface ChipiClientProviderProps {
  children: React.ReactNode;
  apiPublicKey: string;
  environment?: "development" | "production";
}

/**
 * Pure client component that handles all React hook imports
 * This component is marked with 'use client' to avoid server-side issues
 */
export function ChipiClientProvider({
  children,
  apiPublicKey,
  environment = "production",
}: ChipiClientProviderProps) {
  // Create config
  const config = React.useMemo(
    (): ChipiSDKConfig => ({
      apiPublicKey,
      environment,
    }),
    [apiPublicKey, environment]
  );

  return <ChipiProvider config={config}>{children}</ChipiProvider>;
}
